import React from 'react';
import closeIcon from "../../../assets/images/common/black-arrow.svg";
import chatbot from "../../../assets/images/help-support/chatbot.svg";
import { useHistory } from "react-router-dom";
import { call, helpMessage, helpBackground,helpMobileBackground } from '../../Common/Images';

const HelpAndSupport = () => {
  const history = useHistory();

  return (
    <div className="help-support-page-up">
      {/* Close Button */}
      {/* <div className="close-btn-up">
        <img src={closeIcon} alt="close" className="img-up" onClick={() => history.push('/')} />
      </div> */}

      <div className="help-support-container-up">
        {/* Left Section */}
        <div className="help-left-up">
          <h2 className="title-up">Get in touch</h2>
          <p className="subtitle-up">With a member of our team</p>

          <div className="contact-block-up">
            <div className="contact-item-up">
              <img src={helpMessage} alt="Chat Icon" className="icon-up msg-up" />
              <a href="mailto:hello@millionspaces.com" className="contact-text-up">
                hello@millionspaces.com
              </a>
            </div>
            <div className="contact-item-up">
              <img src={call} alt="Phone Icon" className="icon-up phone-up" />
              <a href="tel:0117811811" className="bold-text-up">
                0117 811 811
              </a>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="help-right-up" style={{position: 'relative', overflow: 'visible'}}>
          {/* Desktop background image */}
          <img 
            src={helpBackground} 
            alt="background" 
            className="help-bg-img-up"
          />
          {/* Mobile background image */}
          <img 
            src={helpMobileBackground} 
            alt="mobile background" 
            className="help-bg-img-mobile-up"
          />
          <img src={chatbot} alt="chatbot" className="chatbot-img-up" style={{position: 'relative', zIndex: 1}} />
        </div>
      </div>
    </div>
  );
};

export default HelpAndSupport;
